module.exports = __webpack_public_path__ + "img/130.10.d12a00bf.png";